import { loadStripe } from "@stripe/stripe-js";

/** Test-mode key, used when the build does not provide `VITE_STRIPE_PUBLISHABLE_KEY` (local, staging). */
const STRIPE_TEST_PUBLISHABLE_KEY =
	"pk_test_51QIC04P18jfGO6TN59r4jjhI1vptgIOoec01cHJKMrylHQyKQNM6bl7GpzdGtYuT4KAib8wzwn5jzrIwr7oqBBZt00ycdlOlWQ";

/** Must belong to the same Stripe mode (test/live) as the backend secret key of the environment. */
export const STRIPE_PUBLISHABLE_KEY: string = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY || STRIPE_TEST_PUBLISHABLE_KEY;

export const stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY);
